module.exports = __webpack_public_path__ + "static/media/high-fuel.25d2e615.svg";